(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["carousel"]) return;
  try {
    
    $('.company').slick({
      autoplay: true,
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"]) return;
  try {
    
    $('.slider').slick({
      infinite: true,
      arrows: true,
      autoplay: true,
      nextArrow: '<i class="fa fa-arrow-right slick-next"></i>',
      prevArrow: '<i class="fa fa-arrow-left slick-prev"></i>',
      autoplaySpeed: 6000,
      speed: 600
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topHeader"]) return;
  try {
    
// Get the modal
var modal = document.getElementById('myModal');

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal
btn.onclick = function() {
    modal.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
    modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
}

  } catch(e) { console.error(e); }
})();
      })();
